import { Component, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';

  import { Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-manufacturing',
  templateUrl: './manufacturing.component.html',
  styleUrls: ['./manufacturing.component.css']
})
export class ManufacturingComponent {
  baseUrl = Constants.baseUrl;
isBrowser:boolean=false;

  constructor(
   
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2, private seoService: SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
  {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/manufacturing/"
  },
  "headline": "Manufacturing IT Solutions and Services | Maganti IT",
  "description": "In order to compete in a digitally disrupted environment, industrial businesses must become more agile and increase production efficiency.",
  "image": "https://mitresource.com/assets/images/manufacture/analytics.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-24"
}`;

    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
    
    if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
  this.openCity('ourtabmission');

}
  }


  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Manufacturing IT Solutions and Services | Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'In order to compete in a digitally disrupted environment, industrial businesses must become more agile and increase production efficiency.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Manufacturing IT Solutions and Services | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/manufacturing/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/manufacture/analytics.png' },
      { property: 'og:description', content: 'In order to compete in a digitally disrupted environment, industrial businesses must become more agile and increase production efficiency.' },
    ]);
  }
  activeTab: string = 'ourtabmission'; // Default tab
  openCity(cityName: string): void {
    // Hide all tab content
    const companyTabsContent = document.querySelectorAll('.companytabscontent') as NodeListOf<HTMLElement>;
    companyTabsContent.forEach(content => {
      content.style.display = 'block';
    });

    // Remove "active" class from all tab links
    const companyTabLinks = document.querySelectorAll('.companytablinks') as NodeListOf<HTMLElement>;
    companyTabLinks.forEach(link => {
      link.classList.remove('active');
    });

    // Show the selected tab content
    const selectedTab = document.getElementById(cityName);
    if (selectedTab) {
      selectedTab.style.display = 'block';
    }

    // Set the active tab
    this.activeTab = cityName;
  }
}
